
  Vue.component('qrc-configurator', {
    props: {
      qrcUrl: { type: String, default: '/api/v1/qrcode/get-image?qrcv=1' },
      printMode: { type: Boolean, default: false },
      managerMode: { type: Boolean, default: false },
      showHeader: { type: Boolean, default: true },
      size: { type: String, default: '' }
    },
    data() {
      return {
        idList: 0,
        linkTypesList: [
          { id: -1, key: 'Widget', label: 'Widget', description: `Link al widget Leark per l'inserimento del CV` },
          {
            id: 0,
            key: 'RegisterCandidate',
            label: 'Registrazione candidato',
            description: 'Link alla pagina di registrazione del cadidato.'
          },
          {
            id: 1,
            key: 'RegisterCompany',
            label: 'Registrazione Azienda',
            description: 'Link alla pagina di registrazione per aziende.'
          },
          {
            id: 9999,
            key: 'Register',
            label: 'Registrazione Generica',
            description: 'Link alla pagina di registrazione generica.'
          }
        ],
        formatTypesList: [
          { id: 1, key: 'qrc-only', label: 'Solo QRCode', description: `` },
          {
            id: 2,
            key: 'qrc-ss',
            label: 'Scritte sopra e sotto',
            description: ''
          },
          {
            id: 3,
            key: 'qrc-4l',
            label: 'Scritte su tutti i lati',
            description: ''
          },
          {
            id: 4,
            key: 'qrc-image',
            label: 'Quattro lati con logo',
            description: ''
          }
        ],
        formatType: 3,
        linkType: -1,
        autoPrint: false,
        show: true,
        currentPage: 0,
        seekerId: null,
        seekerLogoUrl: null,
        seekerName: 'LearK',
        seekerCompanySign: '',
        entityType: 1,
        printFormat: '15x15',
        customPrintParameters: null,
        printFormatsList: [
          {
            key: 'a4',
            label: 'Foglio A4',
            description: 'Ideale per stampa su foglio di carta',
            pdfWidth: 210,
            pdfHeight: 297,
            marginTop: 30,
            marginRight: 30,
            marginBottom: 0,
            marginLeft: 30
          },
          {
            key: '15x15',
            label: 'Vetrofania 15cm x 15cm',
            description: `Ideale per l'applicazione su vetrine e banconi`,
            pdfWidth: 150,
            pdfHeight: 150,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0
          },
          {
            key: '50x50',
            label: 'Adesivo  50cm x 50cm',
            description: 'Ideale per adesivi da applicare ad automezzi',
            pdfWidth: 500,
            pdfHeight: 500,
            marginTop: 50,
            marginRight: 50,
            marginBottom: 0,
            marginLeft: 50
          },
          {
            key: '200x200',
            label: 'Cartelloni 2m x 2m',
            description: 'Ideale per cartelloni di grosse dimensioni',
            pdfWidth: 2000,
            pdfHeight: 2000,
            marginTop: 100,
            marginRight: 100,
            marginBottom: 0,
            marginLeft: 100
          }
        ]
      }
    },
    template: '#qrc-configurator',
    computed: {
      title() {
        return this.seekerCompanySign && this.seekerCompanySign != this.seekerName
          ? this.seekerCompanySign
          : this.seekerName
      },
      subTitle() {
        return this.seekerCompanySign && this.seekerCompanySign != this.seekerName ? `di ${this.seekerName}` : ''
      },
      pageHeader() {
        let retVal = {
          title: 'Configura il tuo QRCode',
          subTitle: 'Modifica le opzioni e scarica il QRCode nel formato che preferisci.'
        }
        if (!this.managerMode) {
          retVal = {
            title: 'Ottieni il QR Code da stampare o condividere.',
            subTitle: 'Il widget a portata di smartphone.'
          }
        }
        return retVal
      },
      pages() {
        const retVal = [
          {
            id: 1,
            code: 'link',
            label: 'Link',
            title: 'Scegli il tipo di link',
            subTitle: '',
            titleIcon: 'fa-users-medical fa-swap-opacity'
          },
          {
            id: 2,
            code: 'format',
            label: 'Formato',
            title: 'Scegli il template che prefisci',
            subTitle: '',
            titleIcon: 'fa-users-cog'
          },
          {
            id: 3,
            code: 'print',
            label: 'Dimensioni',
            title: 'Scegli su che supporto vuoi stampare',
            subTitle: '',
            titleIcon: 'fa-users-cog'
          }
        ]
        return retVal.sort((a, b) => (a.id > b.id ? 1 : -1))
      },
      sideMessage() {
        const rightMessage = 'carica il tuo cv'
        const leftMessage = 'lavora con noi'
        const defaultMessage = { leftMessage, rightMessage }
        const messageList = [
          { entityType: 1, ...defaultMessage },
          { entityType: 2, ...defaultMessage, leftMessage: 'facciamo rete' },
          { entityType: 3, ...defaultMessage },
          { entityType: 5, ...defaultMessage, leftMessage: 'diventa volontario' }
        ]
        return messageList.filter(item => item.entityType === this.entityType)[0]
      },
      selectedLinkType() {
        return this.linkTypesList.find(x => x.id == this.linkType)
      },
      selectedPage() {
        return this.pages.find(x => x.id == this.currentPage)
      }
    },
    watch: {},
    methods: {
      setPrintStyle(printStyle = { width: '297', height: '210', margin: '30' }) {
        // Gestione dei formati di stampa
        const elem = document.querySelector('#qrc-print-style')
        if (elem) {
          elem.parentElement.removeChild(elem)
        }
        const style = document.createElement('style')
        style.innerHTML = `@page {size: ${printStyle.width}mm ${printStyle.height}mm; margin : ${printStyle.margin}mm }`
        style.media = 'print'
        style.id = 'qrc-print-style'

        const ref = document.querySelector('script')
        ref.parentNode.insertBefore(style, ref)
      },
      removePrintStyle() {
        const elem = document.querySelector('#qrc-print-style')
        if (elem) elem.parentNode.removeChild(elem)
      },
      showQrCode() {
        this.addPrintStyle()
        this.title = document.title
        document.title = `QR Code - ${this.seekerName}`
        this.show = true
      },
      hideQrCode() {
        console.log(this.showPanelOnly)
        if (!this.showPanelOnly) {
          this.removePrintStyle()
          document.title = this.title
          this.show = false
        }
      },
      printPdfQrCode(event, printFormat) {
        const formatKey = printFormat ?? this.printFormat
        const printParameters = this.customPrintParameters
          ? this.customPrintParameters
          : this.printFormatsList.filter(pf => pf.key == formatKey)[0]
        const self = this
        const htmlContent = document.getElementsByTagName('html')[0].innerHTML
        // const htmlContent = document.getElementById('qrc-component').innerHTML
        const config = {
          url: `/api/v1/qrcode/print`,
          data: {
            htmlContent,
            ...printParameters
          },
          method: 'post',
          responseType: 'blob'
        }
        axios
          .request(config)
          .then(response => {
            const fileName = response.headers['content-disposition'].split('filename=')[1]
            const blob = response.data
            const file = new File([blob], fileName, { type: blob.type })
            saveAs(file)
            window.parent.postMessage({ pdf: 'pdf-done' }, '*')
          })
          .catch(error => {
            self.error = true
            window.parent.postMessage({ pdf: 'pdf-error' }, '*')
          })
          .then(() => {
            // always executed
          })
      },
      printQrCode() {
        EventBus.$emit('vnPopup', {
          message: `<h3><b>Generazione del Pdf in corso</b></h3><h3 class="mt-2">Il file PDF sar&agrave; disponibile tra pochi secondi.</h3> `,
          actions: [{ label: 'Ok', icon: 'fa-check', style: 'info' }],
          cssStyle: { 'z-index': 1060 }
        })

        let printIframe = document.querySelector('#qrc-print-iframe')
        if (!printIframe) {
          printIframe = document.createElement('iframe')
          printIframe.id = 'qrc-print-iframe'
          const ref = document.querySelector('#qrc-print')
          ref.appendChild(printIframe)
        }
        printIframe.src = `/account/seeker/qrcodeprint?${this.seekerId ? `seekerid=${this.seekerId}` : ''}&idList=${
          this.idList
        }&printformat=${this.printFormat}&linktype=${this.linkType}&formattype=${this.formatType}&autoprint=true`
      },
      shareQrCode() {
        const self = this
        const fileName = `LerakQRC-${self.seekerName.replace(/\s/g, '')}.png`
        let blob
        const config = { url: `${this.qrcUrl}&idList=${this.idList}`, method: 'get', responseType: 'blob' }

        axios
          .request(config)
          .then(response => {
            blob = response.data
          })
          .catch(error => {
            self.error = true
          })
          .then(() => {
            const file = new File([blob], fileName, { type: blob.type })

            if (navigator.canShare && navigator.canShare({ files: [file] })) {
              navigator
                .share({
                  files: [file],
                  title: `QR Code - ${self.seekerName}`,
                  text: `${self.seekerName} ${self.qrcText}`
                })
                .then(() => console.log('Share was successful.'))
                .catch(error => console.log('Sharing failed', error))
            } else if (navigator.share) {
              navigator
                .share({
                  title: `QR Code - ${self.seekerName}`,
                  text: `${self.seekerName} ${self.qrcText}`,
                  url: 'https://www.leark.it/'
                })
                .then(() => console.log('Successful share'))
                .catch(error => console.log('Error sharing', error))
            }
          })
      },
      handlePage(e, page) {
        this.currentPage = page
      },
      getSeekerData() {
        const self = this
        axios
          .get(`/api/v1/seeker/`)
          .then(response => {
            const { data: seeker } = response
            self.seekerLogoUrl = seeker.imageLogoUrl
            self.seekerName = seeker.name
            self.seekerCompanySign = seeker.companySign
            self.entityType = seeker.entityType
            if (self.autoPrint) setTimeout(() => self.printPdfQrCode(), 400)
          })
          .catch(error => {
            self.error = true
          })
          .then(() => {
            // always executed
          })
      },
      changeIdList(idList) {
        this.idList = idList
      }
    },
    mounted() {
      EventBus.$on('changeIdList', this.changeIdList)
      const urlParams = new Proxy(new URLSearchParams(window.location.search.toLowerCase()), {
        get: (searchParams, prop) => searchParams.get(prop.toLowerCase())
      })
      this.getSeekerData()

      if (urlParams.linkType) this.linkType = urlParams.linkType
      if (urlParams.idList) this.idList = urlParams.idList
      if (urlParams.formatType) this.formatType = urlParams.formatType
      if (urlParams.printFormat) this.printFormat = urlParams.printFormat
      if (this.printFormat && this.printFormat.toLowerCase() === 'custom') {
        this.customPrintParameters = {
          pdfWidth: urlParams.pdfWidth,
          pdfHeight: urlParams.pdfHeight,
          marginTop: urlParams.marginTop,
          marginRight: urlParams.marginRight,
          marginBottom: urlParams.marginBottom,
          marginLeft: urlParams.marginLeft
        }
      }
      if (urlParams.autoPrint) this.autoPrint = true
      if (!this.printMode) {
        window.addEventListener('message', event => {
          if (event.data && event.data.pdf) {
            const success = event.data.pdf === 'pdf-done'
            EventBus.$emit('vnShow', {
              type: success ? 'success' : 'danger',
              message: success
                ? `Il file Pdf &egrave; stato generato correttamente`
                : 'Errore nella generazione del file Pdf'
            })
          }
        })
      }
    },

    beforeDestroy() {
      EventBus.$off('changeIdList', this.changeIdList)
    }
  })
